/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/**
 * @description WOBO CHATBOT
 */
import React, { Suspense, lazy, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import ChatbotPortal from './portal'

const Chatbot = lazy(
  () =>
    import(
      /* webpackChunkName: "chatbot" */
      './chatbot'
    )
)

const WINDOW_EVENTS = {
  POP_IN: 'Open Chatbot Iframe',
  POP_OUT: 'Open Chatbot Tab',
  CLOSED_CHATBOT: 'Closed Chatbot',
  CHATBOT_TOKEN: 'Chatbot Token',
  CHATBOT_CLIENT: 'Chatbot Client ID',
}

type TokenResponse = {
  access_token: string
  refresh_token: string
  scope: string
  state: string
  success: boolean
  token_type: 'bearer'
}

const ChatbotWrapper = () => {
  const [showChatbot, setChatbotState] = useState(false)
  const [isTokenFetch, setTokenStatus] = useState(false)
  const [childClientId, setChildClient] = useState('')
  const chatbotUrl = `${wbConfig.chatbotUrl}/pop-out`
  const iframeSrc = `${wbConfig.chatbotUrl}/iframe`
  const iconPath = `${wbConfig.baseUrl}/images/icons/menu/topnavigation/chatbot_text.svg`
  const TOKEN_STORE_KEY = 'chatbotToken'
  const getClientAuthToken = async (clientId: string) => {
    if (isTokenFetch) setTokenStatus(false)
    try {
      const res = await axios.get(
        `${wbConfig.baseUrl}/client/generateUserAccessToken?client_id=${clientId}`
      )
      return res.data
    } catch (error) {
      console.warn(
        'Failed auth token by clientId:ChatbotWrapper:getClientAuthToken',
        error
      )
      return null
    }
  }

  const storeToken = (token: TokenResponse): void => {
    localStorage.setItem(TOKEN_STORE_KEY, JSON.stringify(token))
  }

  const getLocalToken = (): TokenResponse | null => {
    let tokenResponse
    try {
      tokenResponse = JSON.parse(
        localStorage.getItem(TOKEN_STORE_KEY) || 'null'
      )
    } catch (error) {
      tokenResponse = 'null'
    }
    return tokenResponse
  }

  const handlePostAuthToken = async (clientId: string) => {
    const accessToken = getLocalToken()
    // if (!accessToken?.access_token) { }
    //generate new token only if there is no token saved
    const token: TokenResponse = await getClientAuthToken(clientId)
    storeToken(token)
    setTokenStatus(true)
    const iframe: any = document.getElementById('chatbot-iframe')
    iframe.contentWindow.postMessage(
      { message: WINDOW_EVENTS.CHATBOT_TOKEN, token },
      iframeSrc
    )
  }

  const popout = () => {
    handlePostAuthToken(childClientId)
    if (isTokenFetch) {
      const newWindow = window.open(
        chatbotUrl,
        'wobo-chatbot',
        'width=417,height=550'
      )
      newWindow.focus()
      setChatbotState(false)
    }
  }

  const handleEventMessages = (origin: string, event: any) => {
    if (origin === chatbotUrl && event.data === WINDOW_EVENTS.POP_IN) {
      setChatbotState(true)
    }
    if (origin === chatbotUrl && event.data === WINDOW_EVENTS.POP_OUT) {
      popout()
    }
    if (origin === chatbotUrl && event.data === WINDOW_EVENTS.CLOSED_CHATBOT) {
      setChatbotState(false)
    }
    if (
      origin === chatbotUrl &&
      event.data?.message === WINDOW_EVENTS.CHATBOT_CLIENT
    ) {
      const clientId = event.data?.clientId || ''
      setChildClient(event.data?.clientId || '')
      handlePostAuthToken(clientId)
    }
  }
  const cbRef = useRef(handleEventMessages)
  useEffect(() => {
    cbRef.current = handleEventMessages // update after each render
  })

  useEffect(() => {
    window.addEventListener(
      'message',
      (event) => {
        const chatbotOrigin = `${event.origin}/chatbot-app/pop-out`

        if (chatbotOrigin !== chatbotUrl) return
        const callback = (event: any) => cbRef.current(chatbotOrigin, event)
        callback(event)
      },
      false
    )
    // const accessToken = getLocalToken()
    // if (accessToken && accessToken?.access_token) {
    //   setTokenStatus(true) //checks if chatbot token is already saved
    // }
    const logoutbtn = document.getElementById('logoutSubmitBtn')
    if (logoutbtn) {
      logoutbtn.addEventListener('click', clearChatToken)
    }
  }, [])

  const clearChatToken = () => {
    localStorage.removeItem(TOKEN_STORE_KEY)
  }

  return (
    <>
      {/* Wobo Chatbot IFRAME Integration */}
      <button
        style={{ background: 'none', border: 'none' }}
        onClick={popout}
        aria-label="Wobo Chatbot"
        title="Wobo Chatbot"
      >
        <img
          width="18px"
          height="20.5px"
          aria-hidden="true"
          style={{
            marginTop: '4.25px',
            cursor: !isTokenFetch ? 'default' : 'pointer',
            marginRight: '5px',
            opacity: !isTokenFetch ? '0.5' : '1',
          }}
          src={iconPath}
        />
      </button>
      {
        // showChatbot &&
        <ChatbotPortal>
          <Suspense fallback={null}>
            <div style={{ visibility: showChatbot ? 'visible' : 'hidden' }}>
              <Chatbot
                showChatbot={showChatbot}
                closeChatbot={() => {
                  setChatbotState(false)
                }}
              />
            </div>
          </Suspense>
        </ChatbotPortal>
      }
    </>
  )
}

export default ChatbotWrapper
